import { render } from "./DeleteButton.vue?vue&type=template&id=473b050c&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=473b050c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-473b050c"

export default script